import type { Map, GeoJSONSource } from "mapbox-gl";
import { COLORS } from "constants/variables";
import type { MapPointFeature } from "../MapPointClusters";

export const updateClusterLayers = (map: Map, clusters: MapPointFeature[]) => {
  const data: GeoJSON.FeatureCollection<GeoJSON.Point> = { type: "FeatureCollection", features: clusters };
  const source = map.getSource("clusters") as GeoJSONSource | undefined;
  if (source) {
    source.setData(data);
    return;
  }
  map.addSource("clusters", { type: "geojson", data });
  map.addLayer({
    id: "clusters", type: "circle", source: "clusters",
    paint: {
      "circle-color": COLORS.Background,
      "circle-radius": { property: "point_count", type: "interval", stops: [[1, 20], [100, 30], [750, 40]] },
    },
  });
  map.addLayer({
    id: "cluster-casing", type: "circle", source: "clusters",
    paint: {
      "circle-color": COLORS.Yellow,
      "circle-radius": { property: "point_count", type: "interval", stops: [[1, 18], [100, 29], [750, 39]] },
    },
  });
  map.addLayer({
    id: "cluster-count", type: "symbol", source: "clusters",
    layout: {
      "text-field": "{point_count_abbreviated}",
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"], "text-size": 12,
    },
  });
};
